/**
 * Abwesenheitsarten anzeigen.
 *
 * Der Name in der Datenbank ist die Rückfallebene, nicht die Anzeige. Auf
 * einer deutschen Oberfläche stand vorher "ANNUAL - Annual Leave", und auf
 * einer französischen ebenso: die Bezeichnung kam direkt aus der Tabelle
 * und kannte keine Sprache.
 *
 * Angezeigt wird deshalb über einen Übersetzungsschlüssel je CODE. Gibt es
 * ihn nicht - weil die Firma sich eine eigene Art angelegt hat -, gilt der
 * Name aus der Datenbank. Das ist genau richtig: eine selbst angelegte Art
 * heisst so, wie die Firma sie genannt hat.
 */

/**
 * @param {(key: string) => string} t
 * @param {{code?: string, name?: string}|null} type
 * @returns {string}
 */
export function leaveTypeLabel(t, type) {
  const code = type?.code || type?.leaveTypeCode || null;
  const name = type?.name || type?.leaveTypeName || null;
  if (!code) {
    return name || '-';
  }
  const key = `leave.type.${code}`;
  const übersetzt = t(key);
  // t() gibt den Schlüssel zurück, wenn es ihn nicht gibt.
  return übersetzt === key ? name || code : übersetzt;
}

/**
 * Der Farbwert zu einem Token.
 *
 * In der Datenbank steht ein NAME, kein Farbwert - Farben kommen in diesem
 * Projekt ausschliesslich aus tokens.css. Ein "#c0392b" in einer Zeile wäre
 * im dunklen Modus falsch und liesse sich nirgends zentral ändern.
 */
const TOKENS = {
  neutral: 'var(--color-text-muted)',
  info: 'var(--color-info)',
  success: 'var(--color-success)',
  warning: 'var(--color-warning)',
  danger: 'var(--color-danger)',
  accent: 'var(--color-accent)',
};

export function leaveTypeColor(token) {
  return TOKENS[token] || TOKENS.neutral;
}

/** Die Abzeichen-Variante zu einem Token. */
export function leaveTypeVariant(token) {
  return token && token !== 'accent' && token in TOKENS ? token : 'neutral';
}
